module.exports = __webpack_public_path__ + "static/media/scavr-text-logo.546cde77.png";